import EditSceneControlPanel from './EditSceneControlPanel';

export default EditSceneControlPanel;
